var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#152233",
    d: "M23 9.5h-3v-3h-1.5v3h-3V11h3v3H20v-3h3zM8 2a3.75 3.75 0 1 1 0 7.5A3.75 3.75 0 0 1 8 2M8 .5A5.25 5.25 0 1 0 8 11 5.25 5.25 0 0 0 8 .5m7.5 21H14v-3.75A3.75 3.75 0 0 0 10.25 14h-4.5A3.75 3.75 0 0 0 2 17.75v3.75H.5v-3.75a5.25 5.25 0 0 1 5.25-5.25h4.5a5.25 5.25 0 0 1 5.25 5.25z"
  })));
};
export default SvgAddIcon;